import { SelectSearchOption } from 'shared/ui';

import { UnitDto } from '../../units';

export const getUnitsSelectOptions = (
  allUnits: UnitDto[],
): SelectSearchOption[] => {
  if (!allUnits) {
    return [];
  }

  const options: SelectSearchOption[] = allUnits.map((unit) => ({
    value: unit.unit_id,
    label: unit.model,
    secondLabel: unit.number,
  }));

  const defaultOption = { label: 'Не выбрано', value: 'None' };

  options.unshift(defaultOption);

  return options;
};
